import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import TrendHistorySource from 'sources/inbox/TrendHistorySource';

class TrendHistoryActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchTrendHistory'));
  }
  fetchTrendHistory(ruleId, itemId, page, pageSize) {
    return dispatch => {
      dispatch(ruleId);
      return TrendHistorySource.fetchTrendHistory(ruleId, itemId).then(
        this.fetchTrendHistorySuccess,
        error => {
          this.fetchTrendHistoryError(error);
          throw error;
        }
      );
    };
  }

  // TODO page and pageSize are not currently being used, for future support if needed
  fetchTrendHistoryPeriod(ruleId, start, end, reference, page, pageSize) {
    return dispatch => {
      dispatch(ruleId);
      return TrendHistorySource.fetchTrendHistoryPeriod(ruleId, start, end, reference).then(
        this.fetchTrendHistorySuccess,
        error => {
          this.fetchTrendHistoryError(error);
          throw error;
        }
      );
    };
  }
}

export default alt.createActions(TrendHistoryActions);
